module.exports = __webpack_public_path__ + "img/progress_026.57767bb6.png";